// Theme utility functions for managing theme state
export type ThemeMode = 'dark' | 'light';

const THEME_STORAGE_KEY = 'altronic-theme-mode';

/**
 * Get the current theme from localStorage or default to 'dark'
 */
export const getThemeMode = (): ThemeMode => {
  if (typeof window === 'undefined') return ('dark');
  
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') {
    return stored;
  }
  return ('dark'); // Default to dark
};

/**
 * Save theme preference to localStorage
 */
export const setThemeMode = (mode: ThemeMode): void => {
  if (typeof window === 'undefined') return;
  
  localStorage.setItem(THEME_STORAGE_KEY, mode);
  applyTheme(mode);
};

/**
 * Apply theme by adding/removing class on document root
 */
export const applyTheme = (mode: ThemeMode): void => {
  if (typeof document === 'undefined') return;
  
  const root = document.documentElement;
  const body = document.body;
  
  // Remove all theme classes
  root.classList.remove('theme-dark', 'theme-light');
  body?.classList.remove('theme-dark', 'theme-light');
  
  // Add new theme class
  const themeClass = `theme-${mode}`;
  root.classList.add(themeClass);
  body?.classList.add(themeClass);
  root.setAttribute('data-theme', mode);
  body?.setAttribute('data-theme', mode);
  
  // console.log('Theme applied:', mode, 'Root classes:', root.classList.toString());
};

/**
 * Initialize theme on app load
 */
export const initTheme = (): ThemeMode => {
  const mode = getThemeMode();
  applyTheme(mode);
  return mode;
};

